import { useEffect, useState } from "react";

export default function useIsChrome() {
  const [isChrome, setIsChrome] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const ua = navigator.userAgent;
      const isChromeBrowser = /Chrome/.test(ua) && !/Edg|OPR|Brave/.test(ua);
      setIsChrome(isChromeBrowser);
    }
  }, []);

  return isChrome;
}
